import { testDataImage } from './test-data-images'

export const testDataMetaforce = {
    dialog: {
        spacing: 10,
        rows: [
            {
                orientation: 0,
                borderWidth: 1,
                spacing: 1,
                columns: [
                    {
                        elements: [
                            {
                                type: 3,
                                property: 'test',
                                value: 'Metaforce',
                                layout: {
                                    order: 2,
                                },
                                styles: {
                                    borderWidth: 0
                                },
                                text: {
                                    level: '1',
                                    alignment: 'left',
                                    fontFamily: 'arial',
                                    size: 24,
                                    bold: false,
                                    italic: false,
                                    underline: false,
                                    color: 'black'
                                }
                            }]
                    },
                    {
                        elements: [
                            {
                                type: 4,
                                property: 'Logo',
                                value: testDataImage.metaforceLogo,
                                placeholder: 'Metaforce logo',
                                layout: {
                                    order: 5,
                                    right: true
                                },
                                styles: {
                                    borderWidth: 0
                                }
                            }]
                    }]
            },
            {
                columns: [
                    {
                        orientation: 1,
                        borderWidth: 1,
                        spacing: 10,
                        elements: [
                            {
                                type: 0,
                                property: 'test',
                                value: 'Test Change the email address you want associated with your account \n this is a test',
                                layout: {
                                    order: 3,
                                },
                                styles: {
                                    borderWidth: 0
                                },
                                text: {
                                    alignment: 'left',
                                    fontFamily: 'arial',
                                    size: 14,
                                    bold: false,
                                    italic: false,
                                    underline: false,
                                    color: 'grey'
                                }
                            },
                            {
                                type: 2,
                                property: 'Email',
                                value: '',
                                placeholder: 'you@example.com',
                                layout: {
                                    order: 4,
                                },
                                styles: {
                                    borderWidth: 1
                                },
                                text: {
                                    alignment: 'left',
                                    fontFamily: 'arial',
                                    bold: false,
                                    italic: false,
                                    underline: false,
                                    color: 'grey'
                                }
                            },
                            {
                                type: 5,
                                property: 'Date',
                                value: '',
                                placeholder: 'Pick your date',
                                layout: {
                                    order: 7,
                                },
                                styles: {
                                    borderWidth: 0
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    },
    demoDialog: {
        space: 10,
        rows: [
            {
                columns: [
                    {
                        borderWidth: 0,
                        elements: [
                            {
                                type: 3,
                                property: 'test',
                                value: 'Metaforce',
                                layout: {
                                    order: 2,
                                },
                                styles: {
                                    borderWidth: 0
                                },
                                text: {
                                    level: '1',
                                    alignment: 'left',
                                    fontFamily: 'arial',
                                    size: 24,
                                    bold: false,
                                    italic: false,
                                    underline: false,
                                    color: 'black'
                                }
                            }]
                    },
                    {
                        contentAlign: 'right',
                        borderWidth: 0,
                        elements: [
                            {
                                type: 4,
                                property: 'Logo',
                                value: testDataImage.metaforceLogo,
                                placeholder: 'Metaforce logo',
                                width: 80,
                                layout: {
                                    order: 5,
                                    right: true
                                },
                                styles: {
                                    borderWidth: 0
                                }
                            }]
                    }]
            },
            {
                columns: [
                    {
                        backgroundColor: '#f0f0ef',
                        contentAlign: 'center',
                        space: 3,
                        elements: [
                            {
                                type: 3,
                                property: 'test',
                                value: 'Hei Petter Dybdahl',
                                layout: {
                                    order: 2,
                                },
                                styles: {
                                    borderWidth: 0
                                },
                                text: {
                                    level: '1',
                                    alignment: 'center',
                                    fontFamily: 'arial',
                                    size: 30,
                                    bold: false,
                                    italic: false,
                                    underline: false,
                                    color: 'black'
                                }
                            }]
                    }]
            },
            {
                space: 10,
                borderWidth: 1,
                borderColor: '#666',
                columns: [
                    {
                        contentAlign: 'left',
                        space: 10,
                        elements: [
                            {
                                type: 3,
                                property: 'test',
                                value: 'Metaforce',
                                layout: {
                                    order: 2,
                                },
                                styles: {
                                    borderWidth: 0
                                },
                                text: {
                                    level: '1',
                                    alignment: 'center',
                                    fontFamily: 'arial',
                                    size: 30,
                                    bold: false,
                                    italic: false,
                                    underline: false,
                                    color: 'black'
                                }
                            }
                        ]
                    },
                    {
                        contentAlign: 'right',
                        elements: [
                            {
                                type: 4,
                                property: 'Logo',
                                value: testDataImage.metaforceLogo,
                                placeholder: 'Metaforce logo',
                                layout: {
                                    order: 5
                                },
                                styles: {
                                    borderWidth: 0
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    },

    ////
    //// METAFORCE DIALOG
    ////

    metaforceDialog: {
        space: 10,
        rows: [
            {
                columns: [
                    {
                        borderWidth: 0,
                        elements: [
                            {
                                type: 3,
                                property: 'test',
                                value: 'Metaforce',
                                layout: {
                                    order: 2,
                                },
                                styles: {
                                    borderWidth: 0
                                },
                                text: {
                                    level: '1',
                                    alignment: 'left',
                                    fontFamily: 'arial',
                                    size: 24,
                                    bold: false,
                                    italic: false,
                                    underline: false,
                                    color: 'black'
                                }
                            }]
                    },
                    {
                        contentAlign: 'right',
                        borderWidth: 0,
                        elements: [
                            {
                                type: 4,
                                property: 'Logo',
                                value: testDataImage.metaforceLogo,
                                placeholder: 'Metaforce logo',
                                width: 80,
                                layout: {
                                    order: 5,
                                    right: true
                                },
                                styles: {
                                    borderWidth: 0
                                }
                            }]
                    }]
            },
            {
                columns: [
                    {
                        backgroundColor: '#ff7578',
                        contentAlign: 'center',
                        space: 3,
                        elements: [
                            {
                                type: 3,
                                property: 'test',
                                value: 'Hello Petter Dybdahl',
                                layout: {
                                    order: 2,
                                },
                                styles: {
                                    borderWidth: 0
                                },
                                text: {
                                    level: '1',
                                    alignment: 'center',
                                    fontFamily: 'arial',
                                    size: 30,
                                    bold: false,
                                    italic: false,
                                    underline: false,
                                    color: 'white'
                                }
                            }]
                    }]
            },
            {
                space: 10,
                backgroundColor: '#f0f0ef',
                columns: [
                    {
                        contentAlign: 'center',
                        space: 7,
                        elements: [
                            {
                                type: 0,
                                property: 'test',
                                value: 'Fill in your details below and we’ll be in touch with more information.',
                                layout: {
                                    order: 2,
                                },
                                styles: {
                                    borderWidth: 0
                                },
                                text: {
                                    level: '1',
                                    alignment: 'center',
                                    fontFamily: 'arial',
                                    size: 23,
                                    bold: false,
                                    italic: false,
                                    underline: false,
                                    color: 'black'
                                }
                            }
                        ]
                    },
                    {
                        contentAlign: 'right',
                        elements: [
                            {
                                type: 4,
                                property: 'Logo',
                                value: testDataImage.happyImageSmall,
                                placeholder: 'Metaforce logo',
                                width: 240,
                                layout: {
                                    order: 5
                                },
                                styles: {
                                    borderWidth: 0
                                }
                            }
                        ]
                    }
                ]
            },
            {
                columns: [
                    {
                        elements: [
                            {
                                type: 2,
                                inputType: 2,
                                property: 'test',
                                value: 'Metaforce',
                                label: 'Monthly Savings',
                                placeholder: 'Monthly savings amount',
                                leadingText: '$',
                                trailingText: 'USD',
                                layout: {
                                    order: 2,
                                },
                                styles: {
                                    borderWidth: 1
                                },
                                text: {
                                    alignment: 'center',
                                    fontFamily: 'arial',
                                    size: 18,
                                    bold: false,
                                    italic: false,
                                    underline: false,
                                    color: 'black'
                                }
                            }
                        ]
                    }
                ]
            },
            {
                columns: [
                    {
                        elements: [
                            {
                                type: 5,
                                property: 'test',
                                value: 'Metaforce',
                                label: 'Start Date',
                                placeholder: 'Click to enter date',
                                layout: {
                                    order: 2,
                                },
                                styles: {
                                    borderWidth: 1
                                },
                                text: {
                                    level: '1',
                                    alignment: 'center',
                                    fontFamily: 'arial',
                                    size: 18,
                                    bold: false,
                                    italic: false,
                                    underline: false,
                                    color: 'black'
                                }
                            }
                        ]
                    }
                ]
            },
            {
                columns: [
                    {
                        elements: [
                            {
                                type: 1,
                                property: 'test',
                                value: 'Metaforce',
                                label: 'Message',
                                layout: {
                                    order: 2,
                                },
                                styles: {
                                    borderWidth: 1
                                },
                                text: {
                                    level: '1',
                                    alignment: 'center',
                                    fontFamily: 'arial',
                                    size: 18,
                                    bold: false,
                                    italic: false,
                                    underline: false,
                                    color: 'black'
                                }
                            }
                        ]
                    }
                ]
            }
            ,
            {
                columns: [
                    {
                      contentAlign: 'right',
                        elements: [
                            {
                                backgroundColor: '#FF6E70',
                                type: 6,
                                property: 'test',
                                value: 'Sign',
                                layout: {
                                    order: 2,
                                },
                                styles: {
                                    borderWidth: 1
                                },
                                text: {
                                    level: '1',
                                    alignment: 'center',
                                    fontFamily: 'arial',
                                    size: 18,
                                    bold: false,
                                    italic: false,
                                    underline: false,
                                    color: '#fff'
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    },

    ////
    //// ALL ELEMENTS
    ////

    allElements: {
        space: 10,
        rows: [
        {
            columns: [
                {
                    borderWidth: '0',
                    elements: [
                        {
                            _id: null,
                            type: 0,
                            inputType: 0,
                            layout: {
                                order: 2,
                                right: null
                            },
                            text: {
                                level: '1',
                                alignment: 'center',
                                fontFamily: 'arial',
                                size: 50,
                                bold: false,
                                italic: false,
                                underline: false,
                                color: 'black'
                            },
                            property: 'test',
                            value: 'All elements',
                            placeholder: null,
                            borderWidth: '0',
                            width: null,
                            label: null,
                            leadingText: null,
                            trailingText: null,
                            backgroundColor: null
                        }
                    ],
                    contentAlign: 'left',
                    backgroundColor: null
                }
            ],
            space: 10
        },
        {
          columns: [
              {
                  borderWidth: '0',
                  elements: [
                      {
                          type: 8,
                          borderWidth: '5px',
                          borderColor: '#f0f0ef',
                      }
                  ],
                  contentAlign: 'center',
                  space: 1
              }
          ],
          space: null,
          backgroundColor: null
      },
            {
                columns: [
                    {
                        contentAlign: 'left',
                        borderWidth: 0,
                        elements: [
                            {
                                type: 4,
                                property: 'Logo',
                                value: 'data:image/png;base64,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',
                                placeholder: 'Metaforce logo',
                                width: 80,
                                layout: {
                                    order: 5,
                                    right: true
                                },
                            }]
                    }]
            },
            {
                columns: [
                    {
                        borderWidth: 0,
                        elements: [
                            {
                                type: 3,
                                property: 'test',
                                value: 'Metaforce',
                                layout: {
                                    order: 2,
                                },
                                text: {
                                    level: '1',
                                    alignment: 'left',
                                    fontFamily: 'arial',
                                    size: 24,
                                    bold: false,
                                    italic: false,
                                    underline: false,
                                    color: 'black'
                                }
                            }]
                    }]
            },
            {
                space: 10,
                backgroundColor: '#f0f0ef',
                columns: [
                    {
                        contentAlign: 'center',
                        space: 7,
                        elements: [
                            {
                                type: 0,
                                property: 'test',
                                value: 'Fill in your details below and we’ll be in touch with more information.',
                                layout: {
                                    order: 2,
                                },
                                text: {
                                    level: '1',
                                    alignment: 'center',
                                    fontFamily: 'arial',
                                    size: 23,
                                    bold: false,
                                    italic: false,
                                    underline: false,
                                    color: 'black'
                                }
                            }
                        ]
                    }
                ]
            },
            {
            columns: [
                {
                    borderWidth: '0',
                    elements: [
                        {
                            type: 8,
                            borderWidth: '5px',
                            borderColor: '#f0f0ef',
                        }
                    ],
                    contentAlign: 'center',
                    space: 1
                }
            ],
            space: null,
            backgroundColor: null
        },
            {
                columns: [
                    {
                        elements: [
                            {
                                type: 2,
                                inputType: 2,
                                property: 'test',
                                value: 'Metaforce',
                                label: 'Textbox',
                                placeholder: 'Monthly savings amount',
                                leadingText: '$',
                                trailingText: 'USD',
                                borderWidth: '3px',
                                layout: {
                                    order: 2,
                                },
                                text: {
                                    alignment: 'center',
                                    fontFamily: 'arial',
                                    size: 18,
                                    bold: false,
                                    italic: false,
                                    underline: false,
                                    color: 'black'
                                }
                            }
                        ]
                    }
                ]
            },
            {
                columns: [
                    {
                        elements: [
                            {
                                type: 2,
                                inputType: 2,
                                property: 'test',
                                value: 'Metaforce',
                                label: 'Textbox with leading and trailing text - label top',
                                labelTop: true,
                                placeholder: 'Monthly savings amount',
                                leadingText: '$',
                                trailingText: 'USD',
                                borderWidth: '3px',
                                layout: {
                                    order: 2,
                                },
                                text: {
                                    alignment: 'center',
                                    fontFamily: 'arial',
                                    size: 18,
                                    bold: false,
                                    italic: false,
                                    underline: false,
                                    color: 'black'
                                }
                            }
                        ]
                    }
                ]
            },
            {
            columns: [
                {
                    borderWidth: '0',
                    elements: [
                        {
                            type: 8,
                            borderWidth: '5px',
                            borderColor: '#f0f0ef',
                        }
                    ],
                    contentAlign: 'center',
                    space: 1
                }
            ],
            space: null,
            backgroundColor: null
        },
            {
                columns: [
                    {
                        elements: [
                            {
                                type: 5,
                                property: 'test',
                                value: 'Metaforce',
                                label: 'Date picker labele on sidee',
                                placeholder: 'Click to enter date',
                                borderWidth: '3px',
                                layout: {
                                    order: 2,
                                },
                                text: {
                                    level: '1',
                                    alignment: 'center',
                                    fontFamily: 'arial',
                                    size: 18,
                                    bold: false,
                                    italic: false,
                                    underline: false,
                                    color: 'black'
                                }
                            }
                        ]
                    }
                ]
            },
            {
                columns: [
                    {
                        elements: [
                            {
                                type: 5,
                                property: 'test',
                                value: 'Metaforce',
                                label: 'Date picker labele on top',
                                labelTop: true,
                                placeholder: 'Click to enter date',
                                borderWidth: '3px',
                                layout: {
                                    order: 2,
                                },
                                text: {
                                    level: '1',
                                    alignment: 'center',
                                    fontFamily: 'arial',
                                    size: 18,
                                    bold: false,
                                    italic: false,
                                    underline: false,
                                    color: 'black'
                                }
                            }
                        ]
                    }
                ]
            },
            {
            columns: [
                {
                    borderWidth: '0',
                    elements: [
                        {
                            type: 8,
                            borderWidth: '5px',
                            borderColor: '#f0f0ef',
                        }
                    ],
                    contentAlign: 'center',
                    space: 1
                }
            ],
            space: null,
            backgroundColor: null
        },
            {
                columns: [
                    {
                        elements: [
                            {
                                type: 1,
                                property: 'test',
                                value: 'Metaforce',
                                label: 'Text Area',
                                borderWidth: '3px',
                                layout: {
                                    order: 2,
                                },
                                text: {
                                    level: '1',
                                    alignment: 'center',
                                    fontFamily: 'arial',
                                    size: 18,
                                    bold: false,
                                    italic: false,
                                    underline: false,
                                    color: 'black'
                                }
                            }
                        ]
                    }
                ]
            },
            {
                columns: [
                    {
                        elements: [
                            {
                                type: 1,
                                property: 'test',
                                value: 'Metaforce',
                                label: 'Text Area label on top',
                                labelTop: true,
                                borderWidth: '3px',
                                layout: {
                                    order: 2,
                                },
                                text: {
                                    level: '1',
                                    alignment: 'center',
                                    fontFamily: 'arial',
                                    size: 18,
                                    bold: false,
                                    italic: false,
                                    underline: false,
                                    color: 'black'
                                }
                            }
                        ]
                    }
                ]
            },
            {
            columns: [
                {
                    borderWidth: '0',
                    elements: [
                        {
                            type: 8,
                            borderWidth: '5px',
                            borderColor: '#f0f0ef',
                        }
                    ],
                    contentAlign: 'center',
                    space: 1
                }
            ],
            space: null,
            backgroundColor: null
        },
            {
                columns: [
                    {
                      contentAlign: 'left',
                        elements: [
                            {
                                backgroundColor: '#FF6E70',
                                type: 6,
                                property: 'test',
                                value: 'Button',
                                layout: {
                                    order: 2,
                                },
                                text: {
                                    level: '1',
                                    alignment: 'center',
                                    fontFamily: 'arial',
                                    size: 18,
                                    bold: false,
                                    italic: false,
                                    underline: false,
                                    color: '#fff'
                                }
                            }
                        ]
                    }
                ]
            },
            {
                columns: [
                    {
                      contentAlign: 'left',
                        elements: [
                            {
                                backgroundColor: '#FF6E70',
                                type: 6,
                                property: 'test',
                                value: 'Button 2',
                                roundedCorners: false,
                                backgroundColor: '#fff',
                                borderWidth: '3px',
                                borderColor: '#FF6E70',
                                layout: {
                                    order: 2,
                                },
                                text: {
                                    level: '1',
                                    alignment: 'center',
                                    fontFamily: 'arial',
                                    size: 18,
                                    bold: false,
                                    italic: false,
                                    underline: false,
                                    color: '#000'
                                }
                            }
                        ]
                    }
                ]
            },
            {
                columns: [
                    {
                      contentAlign: 'left',
                        elements: [
                            {
                                backgroundColor: '#FF6E70',
                                type: 6,
                                property: 'test',
                                value: 'Button 3',
                                roundedCorners: true,
                                backgroundColor: '#FF6E70',
                                borderWidth: '3px',
                                borderColor: '#FF6E70',
                                layout: {
                                    order: 2,
                                },
                                text: {
                                    level: '1',
                                    alignment: 'center',
                                    fontFamily: 'arial',
                                    size: 18,
                                    bold: false,
                                    italic: false,
                                    underline: false,
                                    color: '#fff'
                                }
                            }
                        ]
                    }
                ]
            },
            {
            columns: [
                {
                    borderWidth: '0',
                    elements: [
                        {
                            type: 8,
                            borderWidth: '5px',
                            borderColor: '#f0f0ef',
                        }
                    ],
                    contentAlign: 'center',
                    space: 1
                }
            ],
            space: null,
            backgroundColor: null
        },
            {
                columns: [
                    {
                      contentAlign: 'left',
                        elements: [
                            {
                                type: 7,
                                property: 'checkbox',
                                value: false,
                                layout: {
                                    order: 2,
                                },
                                text: {
                                    level: '1',
                                    alignment: 'center',
                                    fontFamily: 'arial',
                                    size: 18,
                                    bold: false,
                                    italic: false,
                                    underline: false,
                                    color: '#fff'
                                }
                            }
                        ]
                    }
                ]
            },
            {
                columns: [
                    {
                      contentAlign: 'left',
                        elements: [
                            {
                                type: 7,
                                property: 'checkbox',
                                leadingText: 'text in front',
                                value: false,
                                layout: {
                                    order: 2,
                                },
                                text: {
                                    level: '1',
                                    alignment: 'center',
                                    fontFamily: 'arial',
                                    size: 18,
                                    bold: false,
                                    italic: false,
                                    underline: false,
                                    color: '#fff'
                                }
                            }
                        ]
                    }
                ]
            },
            {
                columns: [
                    {
                      contentAlign: 'left',
                        elements: [
                            {
                                type: 7,
                                property: 'checkbox',
                                trailingText: 'text behind',
                                value: true,
                                layout: {
                                    order: 2,
                                },
                                text: {
                                    level: '1',
                                    alignment: 'center',
                                    fontFamily: 'arial',
                                    size: 18,
                                    bold: false,
                                    italic: false,
                                    underline: false,
                                    color: '#fff'
                                }
                            }
                        ]
                    }
                ]
            },
            {
                columns: [
                    {
                      contentAlign: 'left',
                        elements: [
                            {
                                type: 7,
                                property: 'checkbox',
                                trailingText: 'other background on checked',
                                backgroundColor: '#ff6e70',
                                value: true,
                                layout: {
                                    order: 2,
                                },
                                text: {
                                    level: '1',
                                    alignment: 'center',
                                    fontFamily: 'arial',
                                    size: 18,
                                    bold: false,
                                    italic: false,
                                    underline: false,
                                    color: '#fff'
                                }
                            }
                        ]
                    }
                ]
            },
            {
                columns: [
                    {
                        borderWidth: '0',
                        elements: [
                            {
                                type: 8,
                                borderWidth: '5px',
                                borderColor: '#f0f0ef',
                            }
                        ],
                        contentAlign: 'center',
                        space: 1
                    }
                ],
                space: null,
                backgroundColor: null
            },
            {
                columns: [
                    {
                      contentAlign: 'left',
                        elements: [
                            {
                                type: 16,
                                property: 'checkbox',
                                trailingText: 'other background on checked',
                                backgroundColor: '#ff6e70',
                                value: '',
                                layout: {
                                    order: 2,
                                },
                                options: [
                                  {name: 'Title 1', description: 'Description 1 Description 1 Description 1 Description 1', value: ''},
                                  {name: 'Title 2', description: 'Description 2 Description 2 Description 2 Description 2', value: ''},
                                  {name: 'Title 3', description: 'Description 3 Description 3 Description 3 Description 3', value: ''}
                                ],
                                text: {
                                    level: '1',
                                    alignment: 'center',
                                    fontFamily: 'arial',
                                    size: 18,
                                    bold: false,
                                    italic: false,
                                    underline: false,
                                    color: '#fff'
                                }
                            }
                        ]
                    }
                ]
            },
            {
              columns: [
                  {
                      borderWidth: '0',
                      elements: [
                          {
                              type: 8,
                              borderWidth: '5px',
                              borderColor: '#f0f0ef',
                          }
                      ],
                      contentAlign: 'center',
                      space: 1
                  }
              ],
              space: null,
              backgroundColor: null
          },
            {
                orientation: 0,
                borderWidth: 0,
                spacing: 1,
                columns: [
                    {
                        elements: [
                            {
                                type: 10,
                                property: 'Table',
                                placeholder: 'Metaforce logo',
                                width: 160,
                                maxRows: 10,
                                editable: true,
                                trailingText: '%',
                                options: [
                                  "Fond 1",
                                  "Fond 2",
                                  "Fond 3",
                                  "Fond 4",
                                  "Fond 5",
                                  "Fond 6",
                                ],
                                layout: {
                                    order: 5,
                                    right: false
                                },
                                styles: {
                                    borderWidth: 0
                                }
                            }]
                    }
                  ]
            },
            {
                columns: [
                    {
                        borderWidth: '0',
                        elements: [
                            {
                                type: 8,
                                borderWidth: '2px',
                                borderColor: 'black',
                            }
                        ],
                        contentAlign: 'center',
                        space: 1
                    }
                ],
                space: 10,
                backgroundColor: null
            },
            {
                orientation: 0,
                borderWidth: 0,
                spacing: 1,
                columns: [
                    {
                        elements: [
                            {
                                type: 10,
                                property: 'Table',
                                placeholder: 'Metaforce logo',
                                width: 160,
                                maxRows: 10,
                                editable: false,
                                leadingText: 'kr',
                                options: [
                                  "Fond 1",
                                  "Fond 2",
                                  "Fond 3",
                                  "Fond 4",
                                  "Fond 5",
                                  "Fond 6",
                                ],
                                layout: {
                                    order: 5,
                                    right: false
                                },
                                styles: {
                                    borderWidth: 0
                                }
                            }]
                    }
                  ]
            },
            {
          columns: [
              {
                  borderWidth: '0',
                  elements: [
                      {
                          type: 8,
                          borderWidth: '5px',
                          borderColor: '#f0f0ef',
                      }
                  ],
                  contentAlign: 'center',
                  space: 1
              }
          ],
          space: null,
          backgroundColor: null
      },
            {
                orientation: 0,
                borderWidth: 0,
                spacing: 1,
                columns: [
                    {
                        elements: [
                            {
                                type: 15,
                                property: 'Table',
                                placeholder: 'Metaforce logo',
                                width: 160,
                                maxRows: 10,
                                editable: true,
                                label: '',
                                trailingText: '%',
                                options: [
                                  "Fond 1",
                                  "Fond 2",
                                  "Fond 3",
                                  "Fond 4",
                                  "Fond 5",
                                  "Fond 6",
                                ],
                                layout: {
                                    order: 5,
                                    right: false
                                },
                                styles: {
                                    borderWidth: 0
                                }
                            }]
                    }
                  ]
            },
            {
                orientation: 0,
                borderWidth: 0,
                spacing: 1,
                columns: [
                    {
                        elements: [
                            {
                                type: 15,
                                property: 'Table',
                                placeholder: 'Metaforce logo',
                                width: 160,
                                maxRows: 10,
                                editable: true,
                                label: 'Label side',
                                trailingText: '%',
                                options: [
                                  "Fond 1",
                                  "Fond 2",
                                  "Fond 3",
                                  "Fond 4",
                                  "Fond 5",
                                  "Fond 6",
                                ],
                                layout: {
                                    order: 5,
                                    right: false
                                },
                                styles: {
                                    borderWidth: 0
                                }
                            }]
                    }
                  ]
            },
            {
                orientation: 0,
                borderWidth: 0,
                spacing: 1,
                columns: [
                    {
                        elements: [
                            {
                                type: 15,
                                property: 'Table',
                                placeholder: 'Metaforce logo',
                                width: 160,
                                maxRows: 10,
                                editable: true,
                                label: 'Label top',
                                labelTop: true,
                                trailingText: '%',
                                options: [
                                  "Fond 1",
                                  "Fond 2",
                                  "Fond 3",
                                  "Fond 4",
                                  "Fond 5",
                                  "Fond 6",
                                ],
                                layout: {
                                    order: 5,
                                    right: false
                                },
                                styles: {
                                    borderWidth: 0
                                }
                            }]
                    }
                  ]
            }
        ]
    }
}
